export const PREDICT_PRICE_LOADING = 'PREDICT_PRICE_LOADING';
export const GET_PREDICTED_PRICE_TEAM_GENERATION = 'GET_PREDICTED_PRICE_TEAM_GENERATION';
export const PREDICT_PRICE_ERROR = 'PREDICT_PRICE_ERROR';